import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// These files will be generated/updated by the CLI tool later
import enTranslation from './locales/en/translation.json';
import arTranslation from './locales/ar/translation.json';

const savedLanguage = localStorage.getItem('lang_selection') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      ar: { translation: arTranslation },
    },
    lng: savedLanguage, // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;